import { apiClient } from "utils/apiClient";
import { getToken } from "auth/helpers/authApi";
import { useGameRoom } from "context/GameContext";
import { useState, useEffect } from "react";
import { useAsyncFn } from "react-use";

type Note = {
	text: string;
	_id: string;
	deletedAt: Date;
	updatedAt: Date;
};

export const useNote = () => {
	const [notes, setNotes] = useState<Note[]>([]);
	const { roomId } = useGameRoom();
	const [selectedNote, setNote] = useState<Note | null | undefined>(null);
	const [allowedEdit, setAllowedEdit] = useState<boolean>(false);
	const [, doFetch] = useAsyncFn(async () => {
		const response = await apiClient(`notes/${roomId}`, { token: getToken() });
		const note = response.data.find((note: Note) => note._id === selectedNote?._id) || response.data[0];
		setNote(note);
		setNotes(response.data);
		return response;
	}, [roomId]);

	const handleNoteSelect = (id: string) => {
		const note = notes.find((note: Note) => note._id === id);
		if (note) {
			setNote(note);
		}
	};

	const onTextChange = async (text: string, delta, source) => {
		const newNote = {
			...selectedNote,
			text,
		} as Note;
		if (source === "user") {
			setNote(newNote);
			await apiClient(`notes/${selectedNote?._id}`, {
				token: getToken(),
				data: { text },
			});
			doFetch();
		}
	};

	const handleDeleteNote = async () => {
		await apiClient(`notes/remove/${selectedNote?._id}`, {
			token: getToken(),
			data: {},
		});
		doFetch();
	};

	const handleCreateNote = async () => {
		await apiClient(`notes`, {
			token: getToken(),
			data: {
				roomId: roomId,
				text: "",
			},
		});
		doFetch();
	};

	function handleEditNoteFeature() {
		setAllowedEdit(!allowedEdit);
	}

	useEffect(() => {
		doFetch();
	}, [doFetch]);

	return {
		notes,
		selectedNote,
		allowedEdit,
		handleCreateNote,
		handleDeleteNote,
		handleNoteSelect,
		onTextChange,
		handleEditNoteFeature,
	};
};
